var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "vue-button",
      class: [
        _vm.type ? "vue-button_" + _vm.type : "",
        _vm.buttonSize ? "vue-button_" + _vm.buttonSize : "",
        {
          "vue-button_is-disabled": _vm.buttonDisabled,
          "vue-button_is-loading": _vm.loading,
          "vue-button_is-plain": _vm.plain,
          "vue-button_is-round": _vm.round,
          "vue-button_is-circle": _vm.circle,
        },
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType,
      },
      on: { click: _vm.handleClick },
    },
    [
      _vm.loading
        ? _c("i", {
            staticClass: "vue-button__icon-loading fa fa-spinner fa-spin",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && !_vm.loading
        ? _c("i", { staticClass: "vue-button__icon", class: _vm.icon })
        : _vm._e(),
      _vm._v(" "),
      _vm.icon_left && !_vm.loading
        ? _c("i", {
            staticClass: "vue-button__icon vue-button__icon_left",
            class: _vm.icon_left,
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "span",
            { staticClass: "vue-button__title" },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon_right && !_vm.loading
        ? _c("i", {
            staticClass: "vue-button__icon vue-button__icon_right",
            class: _vm.icon_right,
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }